import { z } from 'zod';

export const PCMP_REQUEST_APPLIES_TO = ['STANDARD', 'DISBURSED'] as const;
export const pcmpRequestAppliesToSchema = z.enum(PCMP_REQUEST_APPLIES_TO);
export type PcmpRequestAppliesTo = z.infer<typeof pcmpRequestAppliesToSchema>;

export const PCMP_ACTION_PLAN_KEYS = [
  'URGENT_PAYMENT',
  'PAY_SOURCE_TO_MARKETING',
  'PAY_SOURCE_TO_ACCOUNTS',
  'ADMIN_REJECT',
  'HOLD',
  'RELEASE',
  'RETURN',
] as const;
export const pcmpActionPlanKeySchema = z.enum(PCMP_ACTION_PLAN_KEYS);
export type PcmpActionPlanKey = z.infer<typeof pcmpActionPlanKeySchema>;

export const pcmpRequestCategorySchema = z.object({
  id: z.number(),
  code: z.string(),
  name: z.string(),
  actionPlanKey: pcmpActionPlanKeySchema.nullable(),
  actionPlanLabel: z.string(),
  appliesTo: pcmpRequestAppliesToSchema,
  sortOrder: z.number(),
  isActive: z.boolean(),
});

export type PcmpRequestCategory = z.infer<typeof pcmpRequestCategorySchema>;

export const pcmpRequestCategoriesSchema = z.array(pcmpRequestCategorySchema);

export const pcmpActionPlanSchema = z.object({
  key: pcmpActionPlanKeySchema,
  label: z.string(),
  appliesTo: pcmpRequestAppliesToSchema,
  targetSource: z.enum(['ACCOUNTS', 'MARKETING']).nullable(),
  splitBySource: z.boolean(),
});

export type PcmpActionPlan = z.infer<typeof pcmpActionPlanSchema>;

export const pcmpActionPlansSchema = z.array(pcmpActionPlanSchema);

/** The category code: starts with a letter, A-Z / 0-9 / _, 2 to 30 characters. */
export const PCMP_REQUEST_CATEGORY_CODE_PATTERN = /^[A-Z][A-Z0-9_]{1,29}$/;
export const PCMP_REQUEST_CATEGORY_NAME_MAX = 200;

/** What the API sends on create; `code` is fixed afterwards. */
export interface PcmpRequestCategoryCreatePayload {
  code: string;
  name: string;
  appliesTo: PcmpRequestAppliesTo;
  actionPlanKey: PcmpActionPlanKey | null;
  isActive: boolean;
}

export type PcmpRequestCategoryUpdatePayload = Partial<
  Omit<PcmpRequestCategoryCreatePayload, 'code'>
>;
